import styled from 'styled-components';
import { Row, Col } from 'antd';

export const TableActions = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;